import { useNavigate, useRouteError } from "react-router-dom"

const GeneralError = () => {
  const navigate = useNavigate()
  const error = useRouteError() // Capture route errors

  const errorMessage = error instanceof Error ? error.message : "An unexpected error occurred."

  return (
    <div className="h-svh w-full">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <h1 className="text-[7rem] font-bold leading-tight text-red-600">500</h1>
        <span className="font-medium">Oops! Something went wrong {`:')`}</span>
        <p className="text-center text-muted-foreground">
          We apologize for the inconvenience. <br /> Please try again later.
        </p>

        {import.meta.env.DEV && (
          <div className="mt-4 max-w-lg rounded-lg bg-red-100 p-4 text-red-700 shadow">
            <h2 className="text-lg font-bold">Error Details</h2>
            <pre className="text-xs break-words">{errorMessage}</pre>
          </div>
        )}

        <div className="mt-6 flex gap-4">
          <button
            onClick={() => navigate(-1)}
            type="button"
            className="rounded-full bg-gradient-to-r from-red-500 to-blue-500 py-1 px-4 text-white font-bold disabled:opacity-50"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate("/beyoucoach/dashboard")}
            className="rounded-full bg-blue-500 py-1 px-4 text-white font-bold"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  )
}

export default GeneralError
